import { Container, Grid } from "@mui/material";
import { GlobalBox } from "components/Box/GlobalBox";
import React from "react";
import { AddNotes } from "./AddNotes";
import { TableNotes } from "./TableNotes";
import { ResumeInvoice } from "./ResumeInvoice";
import { TransmitterInvoice } from "./TransmitterInvoice";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { ReceiverInvoice } from "./ReceiverInvoice";
import { CommentsInvoices } from "./CommentsInvoices";
import { ModalV2 } from "components/Modal/ModalV2";
import { useDispatch, useSelector } from "react-redux";
import { prepareInvoiceData } from "redux/actions/invoices/invoicesCashAction";
import { useCashInvoicesHook } from "./useCashInvoicesHook";
import { cashInvoiceConfig } from "./config";

export const CashInvoices = () => {
  const dispatch = useDispatch();
  const {
    readyToSend,
    dataToSend,
    notes,
    resume,
    billingReasons,
    reasonSelect,
    date,
    clearForm, 
    noteUnification
  } = useSelector(({ cashInvoices }) => cashInvoices);
  const { isLoadingComp } = useSelector(({search}) => search)
  const {
    handleSubmit, isReady
  } = useCashInvoicesHook({dataToSend, notes, resume, billingReasons, reasonSelect, date, clearForm, noteUnification})
  return (
    <>
      <GlobalBox
        title={cashInvoiceConfig.title}
        icon={<ReceiptIcon />}
        style={{
          padding: 0,
          marginTop: 32,
        }}
      >
        <Container>
          <Grid container spacing={1}>
            <AddNotes />
            <TableNotes />
            <ResumeInvoice />
            <TransmitterInvoice />
            <ReceiverInvoice />
            <CommentsInvoices />
          </Grid>
        </Container>
      </GlobalBox>
      <ModalV2
        title={
          notes.length === 0
            ? cashInvoiceConfig.modalTitle[0]
            : isReady
            ? cashInvoiceConfig.modalTitle[1]
            : cashInvoiceConfig.modalTitle[2]
        }
        open={readyToSend}
        onClose={() => dispatch(prepareInvoiceData(false))}
        justConfirm
        onSubmit={handleSubmit}
        disabledBtn={!isReady}
        isLoading={isLoadingComp?.loadingInvoicesSendData}
      />
    </>
  );
};
